<template>
  <div>
    <v-form>
      <v-card color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{sayfabaslik}}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn @click="Kaydet()" v-if="kaydetbuton" flat> <span class="hidden-sm-and-down"> Kaydet </span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>

              <v-btn @click="FaturaGuncelle()" v-if="guncellebuton" flat> <span class="hidden-sm-and-down"> Güncelle
                </span>
                <v-icon right dark>create</v-icon>
              </v-btn>
              <v-btn @click="Yazdir()" v-if="guncellebuton" flat> <span class="hidden-sm-and-down"> Yazdır </span>
                <v-icon right dark>print</v-icon>
              </v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="faturasilsor()" v-if="guncellebuton">
                    <v-list-tile-title>Fatura Sil</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="faturanotarihdegistir(0)" v-if="guncellebuton">
                    <v-list-tile-title>Fatura No Değiştir</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="faturanotarihdegistir(1)" v-if="guncellebuton">
                    <v-list-tile-title>Fatura Tarih Değiştir</v-list-tile-title>
                  </v-list-tile>
                  <a target="_self" v-bind:href="'#/faturalar/faturalistesi'">
                    <v-list-tile>
                      <v-list-tile-title>Çıkış</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>

              <v-flex pa-1 xs12 sm6 md6>
                <v-layout row wrap>
                  <v-flex xs12 sm1 md1>

                    <v-card v-if="SerbestFatura.Earchiveakayit!= true && SerbestFatura.Efaturakayit!=true && SerbestFatura.KagitFatura!=true "
                      color="info" height="100%" class="white--text">
                      <v-card-actions>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-start="" justify-center="" fill height>
                            <div class="rotate">
                              <div class="icorta">
                                <span class="subheading text-no-wrap font-weight-bold white--text mb-2">Cari Seçiniz</span>
                              </div>
                            </div>
                          </v-layout>
                        </v-flex>
                      </v-card-actions>
                    </v-card>

                    <v-card v-if="this.SerbestFatura.Earchiveakayit" color="green" height="100%" class="white--text">
                      <v-card-actions>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-start="" justify-center="" fill height>
                            <div class="rotate">
                              <div class="icorta">

                                <span class="subheading text-no-wrap font-weight-bold white--text mb-2">E-Arşiv</span>
                              </div>
                            </div>
                          </v-layout>
                        </v-flex>
                      </v-card-actions>
                    </v-card>

                    <v-card v-if="SerbestFatura.Efaturakayit" color="red" height="100%" class="white--text">
                      <v-card-actions>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-start="" justify-center="" fill height>
                            <div class="rotate">
                              <div class="icorta">

                                <span class="subheading text-no-wrap font-weight-bold white--text mb-2">E-Fatura</span>
                              </div>
                            </div>
                          </v-layout>
                        </v-flex>
                      </v-card-actions>
                    </v-card>

                    <v-card v-if="this.SerbestFatura.KagitFatura" color="pink" height="100%" class="white--text">
                      <v-card-actions>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-start="" justify-center="" fill height>
                            <div class="rotate">
                              <div class="icorta">

                                <span class="subheading text-no-wrap font-weight-bold white--text mb-2">Kağıt Fatura</span>
                              </div>
                            </div>
                          </v-layout>
                        </v-flex>
                      </v-card-actions>
                    </v-card>




                  </v-flex>
                  <v-flex xs12 sm11 md11>
                    <v-card class="white--text">
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row wrap>
                            <v-layout row wrap>
                              <v-flex xs12 sm10 md10>
                                <v-autocomplete hide-details="" clearable append-icon="search" label="Hesap Kodu"
                                  v-model="SerbestFatura.Cari.Kod" :loading="loading" :items="statecari" item-text="text"
                                  item-value="id" :search-input.sync="search1" cache-items=""></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm2 md2>
                                <v-layout align-center="" fill-height="">
                                  <v-btn fab small @click.native="dialogyenicari=true" color="info" icon>
                                    <v-icon>add_box</v-icon>
                                  </v-btn>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-flex xs12 sm12 md12>
                              <span class="body-1 font-weight-bold grey--text mb-2">
                                Ünvan: {{unvan}} </span>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <span class="body-1 font-weight grey--text mb-2">Adres :
                                {{ SerbestFatura.EFaturaBilgi.Adres1}} </span>

                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <span class="body-1 font-weight grey--text mb-2">VKN/TC :
                                {{SerbestFatura.EFaturaBilgi.TcKimlikNo}} /
                                {{SerbestFatura.EFaturaBilgi.VergiDairesi}}-{{SerbestFatura.EFaturaBilgi.VergiNo}}</span>


                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <span class="body-1 font-weight grey--text mb-2">Kredi Limiti:
                                {{kredilimiti}} </span>


                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-flex mt-2 xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm6 md6>
                            <v-autocomplete :items="faturatipi" clearable hide-details="" v-model="SerbestFatura.FaturaTip"
                              item-text="text" item-value="value" label=" Fatura  Tipi"></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-autocomplete hide-details="" :items="EvrakTipi1" v-bind="EvrakTipi1" item-text="Aciklama"
                              v-model="SerbestFatura.Evrak.Evrakkod" clearable item-value="Evrakkod" label="Evrak Tipi"></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <referansmerkezicomp v-model="SerbestFatura.Referans.Kod"></referansmerkezicomp>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <masrafmerkezicomp v-model="SerbestFatura.Masraf.Code"></masrafmerkezicomp>
                          </v-flex>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 md6>
                              <v-autocomplete :items="doviztipi" clearable hide-details="" item-text="DovizUnvan"
                                item-value="DovizKod" v-model="SerbestFatura.Doviz.DovizKod" @select="kurgetir()" label="Döviz Cinsi"></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <dovizinput v-model="SerbestFatura.Kur" :etiket="'Kur'" ::autocomplete="autocomplete"></dovizinput>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field v-model="SerbestFatura.Aciklama" hide-details="" label="Açıklama" value=""></v-text-field>
                            </v-flex>
                            <v-checkbox label="Dövizli Fatura" hide-details></v-checkbox>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-flex>


              <v-flex pa-1 xs12 sm6 md3>
                <v-card v-if="SerbestFatura.Earchiveakayit==true || SerbestFatura.Efaturakayit==true" class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-layout v-if="SerbestFatura.Earchiveakayit" row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="green">
                              <v-toolbar-title> E-Arşiv Bilgileri </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn fab @click="earsivbilgigir()" flat>
                                <v-icon right dark>edit</v-icon>
                              </v-btn>
                            </v-toolbar>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md5>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  Gönderim Şekli:
                                </span>
                              </v-flex>
                              <v-flex xs12 sm6 md7>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  : {{gonderimlabel}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>


                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md5>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  İnternet Satış
                                </span>
                              </v-flex>
                              <v-flex xs12 sm6 md7>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  : {{internetsatislabel}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md5>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  Web Adresi
                                </span>
                              </v-flex>
                              <v-flex xs12 sm6 md7>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  : {{webadresilabel}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md5>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  Ödeme Şekli
                                </span>
                              </v-flex>
                              <v-flex xs12 sm6 md7>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  : {{odemeseklilabel}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md5>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  Ödeme Şekli Açıklama </span>
                              </v-flex>
                              <v-flex xs12 sm6 md7>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  : {{odemesekliaciklamalabel}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12>

                            <v-layout row wrap>
                              <v-flex xs12 sm6 md5>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  Ödeme Aracı </span>
                              </v-flex>
                              <v-flex xs12 sm6 md7>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  : {{odemearacilabel}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex xs12 sm6 md5>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  Ödeme Tarihi</span>
                              </v-flex>
                              <v-flex xs12 sm6 md7>
                                <span class="body-1 font-weight-thin grey--text mb-2">
                                  : {{odemetarihilabel}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                        <v-layout mt-2 v-if="SerbestFatura.Efaturakayit" row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-toolbar flat="" size="120px" dark color="red">
                              <v-toolbar-title> E-Fatura Bilgileri </v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-select hide-details="" :items="efaturatipi" clearable v-model="efaturatipigecici"
                              item-text="text" item-value="value" label=" E-Fatura Tipi"></v-select>
                          </v-flex>
                        </v-layout>

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

              <v-flex pa-1 xs12 sm6 md3>
                <v-flex xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>

                              <tarihcomp :etiket="'Fatura Tarihi'" :detaygizle="true" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="SerbestFatura.Tarih" v-model="SerbestFatura.Tarih"></tarihcomp>


                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field mask="AAAAAAAAAAAAAAAA" :disabled="seridisable" label="Fatura Seri No"
                                    :error-messages="errors.collect('faturaseri')" v-validate="'required'" data-vv-name="faturaseri"
                                    hide-details="" v-model="SerbestFatura.FaturaSeri" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field hide-details="" type="number" :disabled="seridisable" label="Fatura No"
                                    :error-messages="errors.collect('faturano')" v-model="SerbestFatura.FaturaNo"
                                    v-validate="'required'" data-vv-name="faturano" required></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                 <tarihcomp :etiket="'Vade'" :detaygizle="true" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                      v-bind:defaultvalue="'ok'" v-bind:value="SerbestFatura.Vade" v-model="SerbestFatura.Vade"></tarihcomp>

                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-select :items="Tevkifat" v-model="SerbestFatura.TevkivatKdv" item-text="text"
                                hide-details="" item-value="value" @blur="anatevkifatiptal()" clearable="" label=" Tevkifat KDV"
                                @change="anatevkifatkdvkontrol()"></v-select>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-select v-if="gibserigoster" :items="gibseri" hide-details="" item-text="Seri"
                                item-value="Seri" clearable v-model="SerbestFatura.GibSeri" label=" Gib Seri"></v-select>
                            </v-flex>


                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                              <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                                <v-toolbar-title> Dizayn Seçimi </v-toolbar-title>
                                <v-spacer></v-spacer>
                              </v-toolbar>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-select :items="dizaynsec" @change="xsltsec(SerbestFatura.EFaturaShowID.DizaynID)"
                                  v-model="SerbestFatura.EFaturaShowID.DizaynID" hide-details="" clearable item-text="FaturaAciklama"
                                  item-value="FaturaId" label="Dizayn Seç" :error-messages="errors.collect('dizayn')"
                                  v-validate="'required'" data-vv-name="dizayn" required></v-select>

                                <v-select :items="xsltitems" hide-details="" v-model="SerbestFatura.EFaturaShowID.XsltID"
                                  clearable item-text="XsltAciklama" item-value="FaturaId" label="xslt Dosyası Seç"
                                  :error-messages="errors.collect('xslt')" v-validate="'required'" data-vv-name="xslt"
                                  required></v-select>

                                <reportbrosablon ref="reportbrosablon" menudisable v-model="dizayn" dizayngrupadi="Fatura"
                                  objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


              </v-flex>

            </v-layout>


            <v-flex xs12 sm12 md12>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>

                        <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                          <v-toolbar-title> Satır Girişi </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn @click="satirekle()" flat> Satır Ekle
                            <v-icon color="white" right dark>add_box</v-icon>
                          </v-btn>
                        </v-toolbar>
                      </v-flex>

                      <v-layout row="" wrap>
                        <v-flex xs12 sm12 md12>
                          <v-card color="grey lighten-5">
                            <v-list two-line>
                              <template>
                                <v-layout row wrap>

                                  <v-flex xs12 sm4 md3>
                                    <v-layout align-start justify-center row fill-height>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                AÇIKLAMA
                                              </span>
                                            </v-list-tile-sub-title>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md1>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                İSKONTO
                                              </span>
                                            </v-list-tile-sub-title>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md1>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                TEVKİFAT KDV
                                              </span>
                                            </v-list-tile-sub-title>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md2>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                KDV %
                                              </span>
                                            </v-list-tile-sub-title>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md2>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                KDV
                                              </span>
                                            </v-list-tile-sub-title>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md1>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-content>
                                            <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                TUTAR
                                              </span>
                                            </v-list-tile-sub-title>
                                          </v-list-tile-content>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex sm4 md1>
                                    <v-layout row align-center justify-start="">
                                      <v-card flat="">
                                        <v-list-tile>
                                          <v-list-tile-action>
                                            <v-layout align-center="" fill-height="" justify-end>

                                            </v-layout>
                                          </v-list-tile-action>
                                        </v-list-tile>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>

                              </template>

                            </v-list>
                            <v-divider inset></v-divider>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <v-flex xs12 sm12 md12>
                        <v-layout row="" wrap>
                          <v-flex xs12 sm12 md12>
                            <v-card>
                              <template v-for="item in satiritems">
                                <v-layout v-bind:key="item.id" row wrap>

                                  <v-flex xs12 sm4 md3>
                                    <v-layout align-start justify-center="" row fill-height>
                                      <v-card flat="">
                                        <v-list-tile-content>
                                          <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                              {{item.Aciklama}}
                                            </span>
                                          </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md1>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                            {{item.IskontoTutar}} ₺
                                          </span>
                                        </v-list-tile-sub-title>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md1>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                            {{item.TevkifatDetayTutar}} ₺
                                          </span>
                                        </v-list-tile-sub-title>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md2>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                            % {{item.KdvYuzde}}
                                          </span>
                                        </v-list-tile-sub-title>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md2>
                                    <v-layout align-start justify-start="" row fill-height>
                                      <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                            {{item.KdvTutar}} ₺
                                          </span>
                                        </v-list-tile-sub-title>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 sm4 md2>
                                    <v-layout align-start justify-start row fill-height>
                                      <v-card flat="">
                                        <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                            {{item.Tutar}} ₺
                                          </span>
                                        </v-list-tile-sub-title>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex sm4 md1>
                                    <v-layout row align-center justify-start="">
                                      <v-card flat="">
                                        <v-layout align-center="" fill-height="" justify-start="">

                                          <v-flex sm6 md6>
                                            <v-btn icon>
                                              <v-icon @click="satirduzenle(item)" color="teal">edit</v-icon>
                                            </v-btn>
                                          </v-flex>
                                          <v-flex sm6 md6>
                                            <v-btn @click="satirsilsor(item)" icon>
                                              <v-icon color="red">delete</v-icon>
                                            </v-btn>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                                <v-divider :key="item.id" inset></v-divider>
                              </template>


                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>


                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-container>

          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm12 md12>
                <v-layout justify-end="" row>
                  <v-flex xs12 sm12 md4>
                    <v-card class="white--text">
                      <v-layout>
                        <v-flex xs2 sm2 md2>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <v-icon color="info" large="">queue</v-icon>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm10 md8>

                          <v-card-title primary-title="">
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-bold">
                                      Tutar
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs12 sm8 md8>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-bold">
                                      : {{SerbestFatura.Tutarlar.ToplamTutar.toFixed(2)}} ₺

                                    </span>

                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-bold">
                                      İskonto
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs12 sm8 md8>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-bold">
                                      : {{SerbestFatura.Tutarlar.Iskonto.toFixed(2)}} &#8378; </span>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-bold">
                                      Tevkifat:
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs12 sm8 md8>
                                  <v-list-tile-title>
                                    <span class="subheading grey--text font-weight-bold">
                                      : {{SerbestFatura.Tutarlar.TevkifatKdv.toFixed(2)}} &#8378; </span>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>



                          </v-card-title>

                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>
                      <v-card-actions class="pa-3"> <span class="subheading grey--text font-weight-bold">
                          Genel Toplam</span><span class="subheading grey--text font-weight-bold">
                          : {{SerbestFatura.Tutarlar.FaturaToplam.toFixed(2)}} ₺
                          ({{SerbestFatura.Tutarlar.Kdv.toFixed(2)}} &#8378; KDV Dahil)</span>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

          </v-container>



          <!--


          <v-container fluid="">
            <v-layout row="" wrap>

              <v-expansion-panel :key="1">
                <v-expansion-panel-content style="background-color:#BDBDBD;" ripple :value="1">
                  <div slot="header">Serbest Faturaieaie</div>
                  <v-card color="grey lighten-2">

                    <v-container fluid="">
                      <v-layout row="" wrap="">

                        <v-flex xs12 sm6 md3>
                          <v-layout justify-space-between column>
                            <div class="card__text grey darken-1 white--text">
                              <h3>Fatura Bilgileri</h3>
                            </div>
                            <v-layout>
                              <v-flex xs12 sm6 md6>

                              </v-flex>
                            </v-layout>


                            <v-autocomplete :items="faturatipi" clearable hide-details="" v-model="SerbestFatura.FaturaTip"
                              item-text="text" item-value="value" label=" Fatura  Tipi"></v-autocomplete>

                            <v-select v-if="gibserigoster" :items="gibseri" hide-details="" item-text="Seri" item-value="Seri"
                              clearable v-model="SerbestFatura.GibSeri" label=" Gib Seri"></v-select>
                            <v-text-field v-model="SerbestFatura.Aciklama" hide-details="" label="Açıklama" value=""></v-text-field>
                            <v-checkbox label="Dövizli Fatura" hide-details></v-checkbox>


                            <v-layout>

                            </v-layout>



                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 md3>
                          <v-layout justify-space-between column>
                            <div class="card__text grey darken-1 white--text">
                              <h3>Ünvan ve Adres Bilgileri</h3>
                            </div>
                            <v-text-field hide-details="" label="Ünvan-1" v-model="SerbestFatura.EFaturaBilgi.Unvani"></v-text-field>
                            <v-text-field hide-details="" label="Ünvan-2" v-model="SerbestFatura.EFaturaBilgi.Unvani2"></v-text-field>
                            <v-text-field label="Adres-1" hide-details="" v-model="SerbestFatura.EFaturaBilgi.Adres1"></v-text-field>
                            <v-text-field label="Adres-2" hide-details="" v-model="SerbestFatura.EFaturaBilgi.Adres2"></v-text-field>
                            <v-text-field label="İlçe/İl" hide-details="" v-model="SerbestFatura.EFaturaBilgi.IlceSehir"></v-text-field>
                            <v-text-field hide-details="" autocomplete='email' label="Email" v-model="SerbestFatura.EFaturaBilgi.Email"></v-text-field>
                            <v-text-field hide-details="" label="Vergi Dairesi" v-model="SerbestFatura.EFaturaBilgi.VergiDairesi"></v-text-field>
                            <v-text-field hide-details="" label="Vergi No" v-model="SerbestFatura.EFaturaBilgi.VergiNo"></v-text-field>
                            <v-text-field hide-details="" mask="###########" label="T.C. Kimlik No" v-model="SerbestFatura.EFaturaBilgi.TcKimlikNo">
                            </v-text-field>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6 md3>
                          <v-layout justify-space-between column>
                            <div class="card__text grey darken-1 white--text">
                              <h3>T.C. İle İşlem Görenler İçin</h3>
                            </div>
                            <v-text-field hide-details="" label="Adı" v-model="SerbestFatura.EFaturaBilgi.Adi"></v-text-field>
                            <v-text-field hide-details="" label="Soyadı" v-model="SerbestFatura.EFaturaBilgi.Soyadi"></v-text-field>
                            <v-text-field hide-details="" label="Ünvanı " v-model="SerbestFatura.EFaturaBilgi.TUnvani"></v-text-field>
                            <v-text-field hide-details="" label="Diğer Adı" v-model="SerbestFatura.EFaturaBilgi.DigerAdi"></v-text-field>
                            <v-text-field hide-details="" label="Ön Adı Eki" v-model="SerbestFatura.EFaturaBilgi.OnAdiEki"></v-text-field>
                            <br>
                            <div class="card__text grey darken-1 white--text">
                              <h3>Seçenekler</h3>
                            </div>
                            <v-checkbox label="Dövizli Fatura" hide-details></v-checkbox>
                            <v-checkbox v-if="gibserigoster" label="Cariye Aktarma" v-model="SerbestFatura.CariAktarma"
                              hide-details></v-checkbox>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm6 md3>
                          <v-layout justify-space-between column>
                            <div class="card__text grey darken-1 white--text">
                              <h3>Fatura Tutar Bilgileri</h3>
                            </div>
                            <v-list two-line style="width:100%;">
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">assignment</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>Toplam </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.ToplamTutar.toFixed(2)}}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider inset></v-divider>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">trending_down</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>İskonto </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.Iskonto.toFixed(2)}} </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider inset></v-divider>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">add</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>Fat.Top. </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.FaturaToplam.toFixed(2)}}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider inset></v-divider>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">add_to_photos</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>K D V. &nbsp; </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.Kdv.toFixed(2)}}</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                              <v-divider inset></v-divider>
                              <v-list-tile>
                                <v-list-tile-action>
                                  <v-icon color="indigo">keyboard_arrow_down</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content style="width:10%">
                                  <v-list-tile-title>Tevkifat </v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-title>:{{SerbestFatura.Tutarlar.TevkifatKdv.toFixed(2)}}
                                  </v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-list>
                            <h3 style="color:red;"> {{this.SerbestFatura.Efaturakayit}}</h3>
                            <h3 style="color:red;"> {{this.SerbestFatura.Earchiveakayit}}</h3>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content style="background-color:#BDBDBD;" :value="2" ripple="">
                  <div slot="header">Satır Girişi</div>
                  <v-card color="grey lighten-2">

                    <v-container fluid>
                      <v-flex xs12 sm4>
                        <v-btn color="info" @click="satirekle()"> Satır Ekle
                          <v-icon right dark>add_circle_outline</v-icon>
                        </v-btn>
                      </v-flex>



                      <div class="flex xs12 sm12 xs12">
                        <v-flex xs12 sm12>
                          <v-card-title>
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="satiritems"
                            :search="search3">
                            <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                            <template slot="items" slot-scope="props">
                              <tr item>
                                <td class="text-xs-left">{{ props.item.MuhasebeKodu }}</td>
                                <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                                <td class="text-xs-left">{{ props.item.Referans.Kod }}</td>
                                <td class="text-xs-left">{{ props.item.Tutar}}</td>
                                <td class="text-xs-left">{{ props.item.DovizTutar }}</td>
                                <td class="text-xs-left">{{ props.item.KdvYuzde }}</td>
                                <td class="text-xs-left">{{ props.item.KdvTutar }}</td>
                                <td class="text-xs-left">{{ props.item.Tip }}</td>
                                <td class="text-xs-left">{{ props.item.IskontoYuzde }}</td>
                                <td class="justify-center layout px-0">
                                  <v-btn icon class="mx-0" @click="satirduzenle(props.item)">
                                    <v-icon color="teal">edit</v-icon>
                                  </v-btn>
                                  <v-btn icon class="mx-0" @click="satirsil(props.item)">
                                    <v-icon color="pink">delete</v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                              Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                            </v-alert>
                          </v-data-table>
                        </v-flex>
                      </div>
                      <v-card>
                        <v-layout row wrap>
                        </v-layout>
                      </v-card>
                    </v-container>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-layout>
          </v-container> -->

        </v-layout>
      </v-card>
    </v-form>

    <v-dialog v-model="faturadialog" scrollable="" max-width="850px">
      <v-card>
        <v-card-title>E-Fatura</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">

            <div class="flex md12">
              <span id="demo2">
              </span>
            </div>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="satirdialog" scrollable="" persistent="" max-width="800px">
      <v-card color="grey lighten-5">
        <v-card-title>Satır Girişi</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-layout row wrap="">


            <v-flex pa-1 xs12 sm6 md6>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>

                    <v-layout justify-space-between column>
                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.MuhasebeKodu" label="Muhasebe Kodu"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.Aciklama" aria-multiline="" label="Açıklama"></v-text-field>

                      <v-text-field v-model="SerbestFaturaDetay.LineNote" hide-details="" aria-multiline="" label="Line Note"></v-text-field>
                      <referansmerkezicomp v-model="SerbestFaturaDetay.Referans.Kod"></referansmerkezicomp>

                      <masrafmerkezicomp v-model="SerbestFaturaDetay.Masraf.Code"></masrafmerkezicomp>



                      <v-text-field type="number" hide-details="" v-model="SerbestFaturaDetay.Miktar" label="Miktar"></v-text-field>

                      <v-select v-model="SerbestFaturaDetay.Birim" hide-details="" label="Birim" item-text="text"
                        item-value="value" :items="birim" persistent-hint></v-select>

                      <parainput v-model="SerbestFaturaDetay.BirimFiyat" :etiket="'Birim Fiyat'" :autocomplete="autocomplete"></parainput>

                      <parainput v-model="SerbestFaturaDetay.Tutar" :etiket="'Tutar'" :autocomplete="autocomplete"></parainput>

                      <parainput v-model="SerbestFaturaDetay.DovizTutar" :etiket="'Döviz Tutar'" ::autocomplete="autocomplete"></parainput>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>



            <v-flex pa-1 xs12 sm6 md6>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-select hide-details="" :items="kdvtipi" label="KDV Tipi" v-model="SerbestFaturaDetay.KdvTip"
                        item-text="text" clearable item-value="value"></v-select>
                      <v-layout>
                        <yuzdeinput :etiket="'İskonto Yüzde'" v-model="SerbestFaturaDetay.IskontoYuzde"></yuzdeinput>


                        <parainput v-model="SerbestFaturaDetay.IskontoTutar" :etiket="'İskonto Tutar'" :autocomplete="autocomplete"></parainput>

                      </v-layout>
                      <v-layout>
                        <yuzdeinput v-model="SerbestFaturaDetay.KdvYuzde" :etiket="'KDV Yüzdesi'"></yuzdeinput>

                        <parainput v-model="SerbestFaturaDetay.KdvTutar" :etiket="'KDV Tutar'" :aktif="'true'"
                          :autocomplete="autocomplete"></parainput>
                      </v-layout>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.KdvMuhKodu" label="KDV Muhasebe Kodu"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.IskMuhKodu" label="İskonto Muhasebe Kodu"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.KdvKodu" label="KDV Kodu"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.IstisnaKodu" label="İstisna Kodu"></v-text-field>


                      <v-select :items="Tevkifat" v-if="detaytevkifat" hide-details="" item-text="text" item-value="value"
                        clearable v-model="SerbestFaturaDetay.TevkifatDetayOran" @change="Tevkifatkdvhesapla()" label=" Tevkifat KDV Oranı"></v-select>

                      <parainput :aktif="'false'" v-if="detaytevkifat" v-model="SerbestFaturaDetay.TevkifatDetayTutar"
                        :etiket="'Tev. KDV Tutar'" :autocomplete="autocomplete"></parainput>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.TevkifatKodu" label="Tevkifat Kodu"></v-text-field>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex xs12 v-if="ihracat" pa-1 sm12 md12>

              <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                <v-toolbar-title> İhracat Bilgileri </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-flex>


            <v-flex pa-1 v-if="ihracat" xs12 sm6 md6>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>

                      <v-text-field v-model="SerbestFaturaDetay.TeslimBilgileri.SokakAdi" hide-details="" label="Teslim Sokak"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.BinaAdi" label="Teslim Bina"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.BinaNo" label="Teslim Bina No"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimSehir" label="Teslim İli"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu" label="Teslim Posta Kodu"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimUlke" label="Teslim Ülke"></v-text-field>

                      <v-select label="Teslim Ödeme" clearable="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme"
                        :items="teslimodeme"></v-select>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>



            <v-flex pa-1 v-if="ihracat" xs12 sm6 md6>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>

                      <v-text-field v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimSarti" hide-details="" label="Teslim Şartı"></v-text-field>

                      <v-text-field hide-details="" :error-messages="errors.collect('gtip')" v-validate="'min:4'"
                        data-vv-name="gtip" v-model="SerbestFaturaDetay.TeslimBilgileri.GTIPNo" label="GTIP No"></v-text-field>

                      <v-select :items="transferkodu" hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TransferKodu"
                        label="Transfer Kodu" item-text="text" item-value="value" max-height="400"></v-select>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinNo" label="Kabin No"></v-text-field>

                      <v-text-field type="number" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinAdedi" hide-details=""
                        label="Kabin Adedi"></v-text-field>

                      <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinCinsi" label="Kabin Cinsi"></v-text-field>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-layout>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="satirdialog=false">İptal</v-btn>

          <v-btn v-if="satirkaydetbuton" color="blue darken-1" flat @click.native="satirkaydet()">Satır Ekle</v-btn>


          <v-btn v-if="satirguncellebuton" color="blue darken-1" flat @click.native="satirguncellekaydet()">Güncelle</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogdegistir" scrollable="" persistent="" max-width="400px">
      <v-card color="grey lighten-5">
        <v-card-title>Fatura Bilgi Değiştir</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-flex ma-1 xs12 sm12 md12>
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>

                  <v-flex xs12 sm12 md12>
                    <div v-if="islemturu==1">
                      <tarihcomp :etiket="'Tarih'" v-bind:value="ChangeTarih" v-model="ChangeTarih"></tarihcomp>
                    </div>
                    <div v-if="islemturu==0">
                      <v-layout>
                        <v-flex xs12 sm12 md12>
                          <v-text-field hide-details="" type="number" label="Fatura No" v-model="ChangeFaturaNo"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialogdegistir=false">İptal</v-btn>
          <v-btn color="blue darken-1" flat @click="faturabilgidegistir()">Değiştir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogearsiv" scrollable="" persistent="" max-width="400px">
      <v-card color="grey lighten-5">
        <v-card-title>E-Arşiv Bilgileri Girişi</v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
            <v-card class="white--text">
              <v-card flat="">
                <v-card-actions>


                  <v-layout row="" wrap="">
                    <div class="flex md12">

                      <v-select :items="gonderimsekli" hide-details="" v-model="SerbestFatura.EarsivBilgi.GonderimSekli"
                        label="Gönderim Şekli" item-text="text" item-value="value" max-height="400"></v-select>

                      <v-select v-model="SerbestFatura.EarsivBilgi.InternetSatis" hide-details="" :items="odemesekli"
                        label="İnternet Satış" item-text="text" item-value="value" max-height="400" persistent-hint></v-select>

                      <v-select :items="webadresleri" hide-details="" v-model="SerbestFatura.EarsivBilgi.WebAdresi"
                        label="Web Adresi" item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>

                      <v-select :items="odemesekli1" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeSekli"
                        label="Ödeme Şekli" item-text="text" clearable item-value="value" max-height="400"></v-select>

                      <v-select :items="odemesekilleri" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeSekliAciklama"
                        label="Ödeme Şekli Açıklama" item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>

                      <v-select :items="odemearaci" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeAraci"
                        label="Ödeme Aracı" item-text="Aciklama" clearable item-value="ID" max-height="400"
                        persistent-hint></v-select>

                      <tarihcomp :etiket="'Ödeme Tarihi'" hide-details="" :tabindex="'17'" v-bind:value="SerbestFatura.EarsivBilgi.OdemeTarihi"
                        v-model="SerbestFatura.EarsivBilgi.OdemeTarihi"></tarihcomp>

                    </div>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">İptal</v-btn>
          <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogyenicari" scrollable="" persistent="" max-width="400px">
      <v-card color="grey lighten-2">
        <v-card-title>Yeni Cari Kart Ekle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row="" wrap="">
            <v-flex pa-1 xs12 sm6 md12>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-form ref="formcariyegore" v-model="valid" lazy-validation>

                        <v-select :items="musteritipi" hide-details="" v-model="Current.CustomerType" item-text="text"
                          item-value="value" clearable label=" Müşteri Tipi">
                        </v-select>
                        <v-text-field :rules="[v => !!v || 'Bu alan gereklidir']" label="Cari Kod" v-model="Current.Code"
                          hide-details="">
                        </v-text-field>
                        <v-text-field hide-details="" :rules="[v => !!v || 'Bu alan gereklidir']" label="Ünvan" v-model="Current.Title">
                        </v-text-field>
                        <v-text-field hide-details="" label="Telefon Numarası" v-model="Current.Phone1"></v-text-field>
                        <v-text-field hide-details="" label="E-Posta Adresi" v-model="Current.Email"></v-text-field>
                      </v-form>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


            <v-flex pa-1 xs12 sm6 md12>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium ">Fatura Adres
                            Bilgileri</span>
                        </v-card-title>
                      </v-card>
                      <v-text-field hide-details="" label="Vergi Dairesi" v-model="Current.Invoice.TaxOffice"></v-text-field>
                      <v-text-field hide-details="" label="Vergi Numarası" v-model="Current.Invoice.TaxNumber"></v-text-field>
                      <v-text-field hide-details="" label="Posta Kodu" v-model="Current.Invoice.PostCode"></v-text-field>
                      <v-text-field hide-details="" label="Ülke" v-model="Current.Invoice.Country"></v-text-field>
                      <v-text-field hide-details="" label="İl/İlçe" v-model="Current.Invoice.Province"></v-text-field>
                      <v-textarea hide-details="" no-resize v-model="Current.Invoice.Address" label="Adres"></v-textarea>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>

            </v-flex>


            <v-flex pa-1 xs12 sm12 md12>
              <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>


                      <v-card flat="" color="#9E9E9E">
                        <v-card-title>
                          <span class="subheading white--text font-weight-medium "> T.C. Kimlik ile
                            işlem gören için</span>
                        </v-card-title>
                      </v-card>

                      <v-text-field hide-details="" label="T.C. Kimlik Numarası" value="" mask="###########" v-model="Current.Invoice.IdentityNumber"></v-text-field>
                      <v-text-field hide-details="" label="Adı" v-model="Current.Invoice.PerFirstName" required>
                      </v-text-field>
                      <v-text-field hide-details="" label="Soyadı" v-model="Current.Invoice.PerFamilyName" required>
                      </v-text-field>
                      <v-text-field hide-details="" label="Ünvan" v-model="Current.Invoice.PerTitle" required>
                      </v-text-field>
                      <v-text-field hide-details="" label="Diğer Adı" v-model="Current.Invoice.PerMiddleName" required>
                      </v-text-field>
                      <v-text-field hide-details="" label="Ön Adı Eki" v-model="Current.Invoice.PerNameSuffix" required>
                      </v-text-field>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>







          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="dialogyenicari=false">İptal</v-btn>
          <v-btn color="blue darken-1" flat @click.native="yenicarikaydet()">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Fatura bilginiz getiriliyor... Lütfen Bekleyiniz.
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogsor" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Uyarı !</v-card-title>
        <v-card-text>Bu kayıtı silmek istediğinize emin misiniz?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click.native="dialogsor=false">İptal</v-btn>
          <v-btn v-if="faturasilbtn" color="info" flat @click="faturasil()">Tamam</v-btn>

          <v-btn v-if="satirsilbtn" color="info" flat @click="satirsil()">Tamam</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import dovizinput from '../customcomp/dovizinput'
  import yuzdeinput from '../customcomp/yuzdeinput'
  import tarihcomp from '../customcomp/tarihim'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";




  export default {
    props: {
      operation: ''
    },

    data() {
      return {
        efaturatipi: [{
            text: 'Ticari',
            value: '0'
          },
          {
            text: 'Temel',
            value: '1'
          },
          {
            text: 'İhracat',
            value: '2'
          }
        ],
        silinecekkayit: null,
        dialogsor: false,
        efaturatipigecici: 0,
        webadresilabel: null,
        odemeseklilabel: null,
        odemesekliaciklamalabel: null,
        odemearacilabel: null,
        odemetarihilabel: null,
        internetsatislabel: null,
        gonderimlabel: null,

        valid: true,
        Current: {
          CompanyCode: '',
          Code: null,
          Title: null,
          Phone1: '',
          CreditLimit1: 0,
          Phone2: '',
          Mobile: '',
          Web: '',
          Email: '',
          AccountGroup: '',
          Type: '',
          CMCode: '',
          Reserved1: '',
          Reserved2: '',
          Authorized: '',
          WarningNote: '',
          InfoNote: '',
          CustomerType: '',
          TicketBill: '',
          EInvoiceType: '',
          PostCodeLabel: '',
          EInvoiceCustomer: '',
          MultiPostUse: false,
          EArchiveSendType: false,
          EArchiveSendPaper: false,
          CreditLimit: 0,
          CreditLimitCurrencyAmount: 0,
          CreditLimitCurrency: '',
          WebPassword: '',
          PinCode: '',
          MileCode: '',
          ExpiryDayDomestic: '',
          ExpiryTypeDomestic: '',
          ExpiryDayInt: '',
          ExpiryTypeInt: '',
          ExpiryDayGeneral: '',
          ExpiryTypeGeneral: '',
          DiscountGeneral: '',
          DiscountDom: '',
          DiscountInt: '',
          DiscountDomService: '',
          DiscountIntService: '',
          TaxFree: '',
          ExternalCurrentCode: '',
          ExternalAccountingCode: '',
          StreamCurrentCode: '',
          ArkmanStreamCode: '',
          ExpenseCenter: null,
          TemplateID: '',
          ProfileForced: '',
          EventIDForced: '',
          MainAccount: '',
          Invoice: {
            Address: '',
            PostCode: '',
            Province: '',
            Country: '',
            TaxNumber: '',
            TaxOffice: '',
            IdentityNumber: '',
            PerFirstName: '',
            PerFamilyName: '',
            PerTitle: '',
            PerMiddleName: '',
            PerNameSuffix: '',
            NoPrint: '',
            CustomerPersonelNoInvoice: '',
            DeliveryAddress: '',
            DeliveryName: ''
          },
          Contract: {
            ContractNumber: '',
            ContractDate: '',
            PaymentType: '',
            BankAccountNumber: '',
            BankBranchOffice: '',
            InvoiceRowNumber: '',
            InvoicePassengerName: '',
            InvoiceFlightNumber: ''
          }
        },


        musteritipi: [{
            text: 'Bireysel',
            value: 'B'
          },
          {
            text: 'Kurumsal',
            value: 'K'
          }
        ],
        dialogyenicari: false,

        headers: [{
            text: 'Muh. Kod',
            value: 'MuhasebeKodu'
          },
          {
            text: 'Açıklama ',
            value: 'Aciklama',

          },
          {
            text: 'Referans',
            value: 'Referans.Kod'
          },
          {
            text: 'Tutar',
            value: 'Tutar',
          },
          {
            text: 'Döviz Tutar',
            value: 'DovizTutar',
          },
          {
            text: 'KDV Yüzde',
            value: 'KdvYuzde',
          },
          {
            text: 'KDV Tutar',
            value: 'KdvTutar',
          },
          {
            text: 'Tip',
            value: 'Tip',
          },
          {
            text: 'İskonto Yüzde ',
            value: 'IskontoYuzde',
          },
          {
            text: 'İşlem ',
            value: '',
          }
        ],
        gibserigoster: true,
        autocomplete: 'autocomplete',
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        yok: false,
        statesecili: [{
          Kod: 'Kod',
          Unvan: 'Unvan',
          newProp: 'Kod' + ' - ' + 'Unvan'
        }],
        statecari: [],
        secilensatirno: -1,
        search3: '',
        search1: '',
        loading: false,
        caritext: '',
        cariid: '',
        aktifdate: false,
        nefaturasi: 'serbest',

        SerbestFatura: {
          SirketKodu: '',
          SerbestFaturaDetay: [],
          Serbest: true,
          AlisSatis: false,
          FaturaSeri: '',
          FaturaNo: '',
          Update: false,
          FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
          Evrak: {
            Evrakkod: ''
          },
          Cari: {
            Kod: ''
          },
          EFaturaBilgi: {
            Unvani: '',
            Unvani2: '',
            Adres1: '',
            Adres2: '',
            IlceSehir: '',
            Email: '',
            VergiDairesi: '',
            VergiNo: '',
            TcKimlikNo: '',
            Adi: '',
            Soyadi: '',
            TUnvani: '',
            DigerAdi: '',
            OnAdiEki: '',
          },
          Tarih: null,
          GibSeri: '',
          Vade: null,
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Aciklama: '',
          Doviz: {
            DovizKod: ''
          },
          Kur: 0,
          TevkivatKdv: 0,
          FaturaID: 0,
          CariAktarma: false,
          Tutarlar: {
            ToplamTutar: 0,
            Iskonto: 0,
            FaturaToplam: 0,
            Kdv: 0,
            TevkifatKdv: 0
          },
          Efaturakayit: false,
          Earchiveakayit: false,
          Kagitfatura: false,
          EarsivBilgi: {
            GonderimSekli: '',
            InternetSatis: '',
            pWebAdresi: '',
            OdemeSekli: '',
            OdemeSekliAciklama: '',
            OdemeAraci: '',
            OdemeTarihi: ''
          },
          EFaturaShowID: {
            EFaturaID: null,
            EFaturaGuid: null,
            FaturaStatus: null,
            PdfID: null,
            DizaynID: null,
            XsltID: null

          }
        },

        SerbestFaturaDetayList: [],

        SerbestFaturaDetay: {
          MuhasebeKodu: '',
          Aciklama: '',
          LineNote: '',
          Referans: {
            Kod: ''
          },
          Masraf: {
            Code: ''
          },
          Miktar: 0,
          Birim: '',
          BirimFiyat: 0,
          Tutar: 0,
          DovizTutar: 0,
          IskontoYuzde: 0,
          IskontoTutar: 0,
          KdvTip: 'D',
          KdvYuzde: 0,
          KdvTutar: 0,
          KdvMuhKodu: '',
          IskMuhKodu: '',
          KdvKodu: '',
          IstisnaKodu: '',
          TevkifatKodu: '',
          Tip: '',
          TevkifatDetayTutar: 0,
          TevkifatDetayOran: 0,

          TeslimBilgileri: {
            SokakAdi: '',
            BinaAdi: '',
            BinaNo: '',
            TeslimSehir: '',
            TeslimPostaKodu: '',
            TeslimUlke: '',
            TeslimSarti: '',
            GTIPNo: '',
            TransferKodu: '',
            KabinNo: '',
            KabinAdedi: '',
            KabinCinsi: '',
            TeslimOdeme: ''
          }

        },

        SerbestFaturaToplamTutarBilgileri: {
          ToplamTutar: 0,
          Iskonto: 0,
          FaturaToplam: 0,
          Kdv: 0,
          TevkifatKdv: 0
        },

        birim: [{
            text: 'adet',
            value: 'adet'
          },
          {
            text: 'kilo',
            value: 'kilo'
          }, {
            text: 'gram',
            value: 'gram'
          }, {
            text: 'metre',
            value: 'metre'
          },
          {
            text: 'Cm',
            value: 'Cm'
          },
        ],
        faturatipi: [{
            text: 'Satış Faturası',
            value: 0
          },
          {
            text: 'İade Faturası',
            value: 1
          }
        ],
        gonderimsekli: [{
            text: 'Kağıt',
            value: 0
          },
          {
            text: 'Elektronik',
            value: 1
          }
        ],

        odemesekli: [{
            text: 'Normal Satış',
            value: 0
          },
          {
            text: 'İnternet Satış',
            value: 1
          }
        ],
        seridisable: false,
        faturagosterbtn: false,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',

        datearsiv: null,
        menuarsiv: false,
        modalarsiv: false,
        dateFormattedarsiv: '',
        yedeksatirkayit: {
          Tutar: 0,
          Kdv: 0,
          Tevkifat: 0,
          iskonto: 0
        },
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        ihracat: false,
        progress: false,
        satirdialog: false,

        gibseri: [],
        satiritems: [],
        referaslist: [],
        EvrakTipi1: [],
        kdvtipi: [{
            text: 'D',
            value: 'D'
          },
          {
            text: 'H',
            value: 'H'
          }
        ],
        Tevkifat: [{
            text: '0/10',
            value: '0'
          },
          {
            text: '1/10',
            value: '0.1'
          },
          {
            text: '2/10',
            value: '0.2'
          },
          {
            text: '3/10',
            value: '0.3'
          },
          {
            text: '4/10',
            value: '0.4'
          },
          {
            text: '5/10',
            value: '0.5'
          },
          {
            text: '6/10',
            value: '0.6'
          },
          {
            text: '7/10',
            value: '0.7'
          },
          {
            text: '8/10',
            value: '0.8'
          },
          {
            text: '9/10',
            value: '0.9'
          },
          {
            text: '10/10',
            value: '1'
          }
        ],

        odemesekli1: [{
            text: 'Kredi-Banka Kartı',
            value: '0'
          },
          {
            text: 'EFT-Havale',
            value: '1'
          },
          {
            text: 'Kapıda Ödeme',
            value: '2'
          },
          {
            text: 'Ödeme Aracısı',
            value: '3'
          },
          {
            text: 'Diğer',
            value: '4'
          }
        ],

        transferkodu: [{
            text: 'Deniz Yolu',
            value: '1'
          },
          {
            text: 'Demir Yolu',
            value: '2'
          },
          {
            text: 'Karayolu',
            value: '3'
          },
          {
            text: 'Havayolu',
            value: '4'
          },
          {
            text: 'Posta',
            value: '5'
          },
          {
            text: 'Çok Araçlı',
            value: '6'
          },
          {
            text: 'Sabit Taşıma Tesisleri',
            value: '7'
          },
          {
            text: 'İç Su Taşımacılığı',
            value: '8'
          }
        ],

        teslimodeme: [{
            text: 'Instrument not defined',
            value: 1
          },
          {
            text: 'Automated clearing house credit',
            value: 2
          },
          {
            text: 'Automated clearing house debit',
            value: 3
          },
          {
            text: 'ACH demand debit reversal',
            value: 4
          },
          {
            text: 'ACH demand credit reversal',
            value: 5
          },
          {
            text: 'ACH demand credit',
            value: 6
          },
          {
            text: 'ACH demand debit',
            value: 7
          },
          {
            text: 'Hold',
            value: 8
          },
          {
            text: 'National or regional clearing',
            value: 9
          },
          {
            text: 'In cash',
            value: 10
          },
          {
            text: 'ACH savings credit reversal',
            value: 11
          },
          {
            text: 'ACH savings debit reversal',
            value: 12
          },
          {
            text: 'ACH savings credit',
            value: 13
          },
          {
            text: 'ACH savings debit',
            value: 14
          },
          {
            text: 'Bookentry credit',
            value: 15
          },
          {
            text: 'Bookentry debit',
            value: 16
          },
          {
            text: 'ACH demand cash concentration/disbursement (CCD) credit',
            value: 17
          },
          {
            text: 'ACH demand cash concentration/disbursement (CCD) debit',
            value: 18
          },
          {
            text: 'ACH demand corporate trade payment (CTP) credit',
            value: 19
          },
          {
            text: 'Cheque',
            value: 20
          },
          {
            text: 'Bankers draft',
            value: 21
          },
          {
            text: 'Certified bankers draft',
            value: 22
          },
          {
            text: 'Bank cheque (issued by a banking or similar establishment)',
            value: 23
          },
          {
            text: 'Certified cheque',
            value: 25
          },
          {
            text: 'Local cheque',
            value: 26
          },
          {
            text: 'ACH demand corporate trade payment (CTP) debit',
            value: 27
          },
          {
            text: 'ACH demand corporate trade exchange (CTX) credit',
            value: 28
          },
          {
            text: 'ACH demand corporate trade exchange (CTX) debit',
            value: 29
          },
          {
            text: 'Credit transfer',
            value: 30
          },
          {
            text: 'Debit transfer',
            value: 31
          },
          {
            text: 'ACH demand cash concentration/disbursement plus (CCD+)',
            value: 32
          },
          {
            text: 'ACH demand cash concentration/disbursement plus (CCD+)',
            value: 33
          },
          {
            text: 'ACH prearranged payment and deposit (PPD)',
            value: 34
          },
          {
            text: ' ACH savings cash concentration/disbursement (CCD) credit',
            value: 35
          },
          {
            text: 'ACH savings cash concentration/disbursement (CCD) debit',
            value: 36
          },
          {
            text: 'ACH savings corporate trade payment (CTP) credit',
            value: 37
          },
          {
            text: 'ACH savings corporate trade payment (CTP) debit',
            value: 38
          },
          {
            text: 'ACH savings corporate trade exchange (CTX) credit',
            value: 39
          },
          {
            text: 'ACH savings corporate trade exchange (CTX) debit',
            value: 40
          },
          {
            text: 'ACH savings cash concentration/disbursement plus (CCD+)',
            value: 41
          },
          {
            text: 'Payment to bank account',
            value: 42
          },
          {
            text: 'ACH savings cash concentration/disbursement plus (CCD+)',
            value: 43
          },
          {
            text: 'Accepted bill of exchange',
            value: 44
          },
          {
            text: 'Referenced home-banking credit transfer',
            value: 45
          },
          {
            text: 'Interbank debit transfer',
            value: 46
          },
          {
            text: 'Home-banking debit transfer',
            value: 47
          },
          {
            text: 'Bank card',
            value: 48
          },
          {
            text: 'Direct debit',
            value: 49
          },
          {
            text: 'Payment by postgiro',
            value: 50
          },
          {
            text: 'Promissory note',
            value: 60
          },
          {
            text: '61    Promissory note signed by the debtor',
            value: 61
          },
          {
            text: 'Promissory note signed by the debtor and endorsed by a bank',
            value: 62
          },
          {
            text: 'Promissory note signed by the debtor and endorsed by a',
            value: 63
          },
          {
            text: ' Promissory note signed by a bank',
            value: 64
          },
          {
            text: 'Promissory note signed by a bank and endorsed by another',
            value: 65
          },
          {
            text: 'Promissory note signed by a third party',
            value: 66
          },
          {
            text: 'Promissory note signed by a third party and endorsed by a',
            value: 67
          },
          {
            text: 'Bill drawn by the creditor on the debtor',
            value: 70
          },
          {
            text: 'Bill drawn by the creditor on a bank',
            value: 74
          },
          {
            text: 'Bill drawn by the creditor, endorsed by another bank',
            value: 75
          },
          {
            text: 'Bill drawn by the creditor on a bank and endorsed by a',
            value: 76
          },
          {
            text: 'Bill drawn by the creditor on a third party',
            value: 77
          },
          {
            text: 'Bill drawn by creditor on third party, accepted and',
            value: 78
          },
          {
            text: 'Not transferable banker s draft',
            value: 91
          },
          {
            text: 'Not transferable local cheque',
            value: 92
          },
          {
            text: 'Reference giro',
            value: 93
          },
          {
            text: 'Urgent giro',
            value: 94
          },
          {
            text: 'Free format giro',
            value: 95
          },
          {
            text: 'Requested method for payment was not used',
            value: 96
          },
          {
            text: 'Clearing between partners',
            value: 97
          }

        ],

        efaturatipi: [{
            text: 'Ticari',
            value: '0'
          },
          {
            text: 'Temel',
            value: '1'
          },
          {
            text: 'İhracat',
            value: '2'
          }
        ],

        islembilgileri: [{
            text: 'Kağıt Fatura',
            value: 'false'
          },
          {
            text: 'Elektronik Fatura',
            value: 'true'
          }
        ],

        doviztipi: [],
        webadresleri: [],
        odemesekilleri: [],
        odemearaci: [],
        dizayn: null,

        ichattipi: [
          'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
        ],

        evethayir: [{
            text: 'Evet',
            value: 'E'
          },
          {
            text: 'Hayır',
            value: 'H'
          },
        ],

        cmkodu: [
          'C', 'M'
        ],
        dizaynsec: [],
        xsltitems: [],
        masrafmerkezi: [],
        dictionary: {
          custom: {
            carikod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            unvan: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            faturaseri: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            faturano: {
              required: () => 'Bu alan boş bırakılamaz',
            },

            dizayn: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            xslt: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            gtip: {
              min: () => 'En az 4 haneli olmalı',
            }

          }
        },
        sayfabaslik: 'Serbest Fatura',
        satirguncellebuton: false,
        satirkaydetbuton: true,
        StartDate: null,
        EndDate: null,
        NumberOfPolicies: '',
        PolicySum: '',
        TotalDebt: '',
        TotalFlatDebt: '',
        kaydetbuton: true,
        guncellebuton: false,
        silbuton: false,
        detaytevkifat: true,
        text1: '',
        denemevalue: 0,

        biletlerfaturalanmasin: null,
        efaturamukellefi: null,
        loadingdialog: false,
        Kdvmuaf: null,
        ciktiistemiyor: null,
        musteribilgitipi: null,
        profilzorunlu: null,
        eventidzorunlu: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        carikod: '',
        unvan: '',
        active: '',
        ex11: 'false',
        dialogearsiv: false,
        earsivdurum: false,
        guidim: null,
        idim: null,
        faturadialog: false,
        kredilimiti: 0,
        dizaynIdget: null,
        xsltIdget: null,
        faturasilbtn: false,
        satirsilbtn: false,
        islemturu: null,
        dialogdegistir: false,
        ChangeTarih: null,
        ChangeFaturaNo: null,

      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {

      faturanotarihdegistir(tur) {
        //tur 0 ise faturatarih 1 ise tarih

        this.dialogdegistir = true;
        if (tur == 0) {
          this.islemturu = 0;
          this.ChangeFaturaNo = this.SerbestFatura.FaturaNo
          this.ChangeTarih = null
        } else if (tur == 1) {
          this.ChangeTarih = this.SerbestFatura.Tarih
          this.ChangeFaturaNo = null
          this.islemturu = 1;
        }

      },
      dizayngetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: 'S',
          DovizliFatura: false,
          HatTipi: false,
          TumFiltre: true
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynsec = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })

      },
      Yazdir() {

        this.dizayn = this.SerbestFatura.EFaturaShowID.PdfID;
        var prm = {
          id: this.SerbestFatura.EFaturaShowID.EFaturaID,
          guid: this.SerbestFatura.EFaturaShowID.EFaturaGuid
        };
        this.$refs.reportbrosablon.Print(prm).then(
          confirm => {

          },
          confirm => {

          }
        );

      },
      xsltgetir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var paramsxslt = {
          CompanyCode: credentials.SirketKodu,

        }
        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body

          this.SerbestFatura.EFaturaShowID.XsltID = this.xsltIdget;

        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })

      },
      xsltsec(Faturaid) {
        this.dizaynsec.forEach(element => {
          if (element.FaturaId == Faturaid) {

            if (element.FaturaXsltId != 0) {
              this.SerbestFatura.EFaturaShowID.XsltID = element.FaturaXsltId
            }

            if (element.FaturaPdfID != 0) {
              this.dizayn = element.FaturaPdfID
            }
          }
        });
      },
      yenicarikaydet() {

        if (this.$refs.formcariyegore.validate()) {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          this.Current.CompanyCode = credentials.SirketKodu
          var current = this.Current
          this.$http.post(auth.API_URL + 'api/Current/New', current, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            if (response.body.Status === true) {


              var seciliitems = [{
                text: this.Current.Code + '-' + this.Current.Title,
                id: this.Current.Code
              }]

              this.statecari = seciliitems
              this.SerbestFatura.Cari.Kod = this.Current.Code;

              this.text1 = response.body.ResponseMessage
              this.snackbar = true

              this.Current.Code = null;
              this.Current.Title = null;
              this.Current.Phone1 = null;
              this.Current.Email = null;
              this.Current.Authorized = null;
              this.Current.CustomerType = null;
              this.Current.EInvoiceType = null;
              this.Current.EArchiveSendType = false;
              this.Current.Invoice.Address = null;
              this.Current.Invoice.PostCode = null;
              this.Current.Invoice.Province = null;
              this.Current.Invoice.Country = null;
              this.Current.Invoice.TaxNumber = null;
              this.Current.Invoice.TaxOffice = null;
              this.Current.Invoice.IdentityNumber = null;
              this.Current.Invoice.PerFirstName = null;
              this.Current.Invoice.PerFamilyName = null;
              this.Current.Invoice.PerTitle = null;
              this.Current.Invoice.PerMiddleName = null;
              this.Current.Invoice.PerNameSuffix = null;
              this.Current.Invoice.CustomerPersonelNoInvoice = null;
              this.Current.Invoice.DeliveryAddress = null;
              this.Current.Invoice.DeliveryName = null;

              this.cariislemler();



              this.dialogyenicari = false;

            } else if (response.body.Status === false) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            }
          }, (response) => {
            if (response.status === 0) {
              this.text1 = response.body.ResponseMessage
              this.snackbar = true
            } else {
              this.text1 = response.statusText
              this.snackbar = true
            }
          })
        } else {
          this.text1 = 'Lütfen gerekli alanları doldurunuz...'
          this.snackbar = true
        }
      },
      satirguncellekaydet() {

        const index = this.secilensatirno

        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar - this.yedeksatirkayit.Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv - this.yedeksatirkayit.Kdv
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv - this.yedeksatirkayit.Tevkifat
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto - this.yedeksatirkayit.iskonto


        if (this.SerbestFaturaDetay.DovizTutar > 0) {
          var n = this.SerbestFaturaDetay.DovizTutar

        }

        var satiryeni = {
          TeslimBilgileri: {
            SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
            BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
            BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
            TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
            TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
            TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
            TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
            GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
            TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
            KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
            KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
            KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
            TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
          },
          MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
          Aciklama: this.SerbestFaturaDetay.Aciklama,
          Referans: {
            Kod: this.SerbestFaturaDetay.Referans.Kod
          },
          Masraf: {
            Code: this.SerbestFaturaDetay.Masraf.Code
          },
          Miktar: this.SerbestFaturaDetay.Miktar,
          LineNote: this.SerbestFaturaDetay.LineNote,
          Birim: this.SerbestFaturaDetay.Birim,
          BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
          Tutar: this.SerbestFaturaDetay.Tutar,
          TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
          DovizTutar: this.SerbestFaturaDetay.DovizTutar,
          TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
          IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
          IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
          KdvKodu: this.SerbestFaturaDetay.KdvKodu,
          KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
          IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
          KdvTutar: this.SerbestFaturaDetay.KdvTutar,
          KdvTip: this.SerbestFaturaDetay.KdvTip,
          KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
          IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
          TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
          Tip: this.SerbestFaturaDetay.Tip,
          AdresBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null
          },
          EfaturaDetayBilgileri: {
            SiparisID: null,
            SiparisTarihi: null
          },
          AdresBilgi: {
            Unvani: null,
            Unvani2: null,
            Adres1: null,
            Adres2: null,
            IlceSehir: null,
            Email: null,
            VergiDairesi: null,
            VergiNo: null,
            TcKimlikNo: null,
            Adi: null,
            Soyadi: null,
            TUnvani: null,
            DigerAdi: null,
            OnAdiEki: null
          }
        }

        var yedeksatiritems = []

        yedeksatiritems = this.satiritems

        this.satiritems = []

        for (var i = 0; i < yedeksatiritems.length; i++) {
          if (index == i) {
            this.satiritems.push(satiryeni)
          } else {
            this.satiritems.push(yedeksatiritems[i])
          }
        }

        this.satirdialog = false
        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar + satiryeni.Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv + satiryeni.KdvTutar
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + satiryeni.TevkifatDetayTutar
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satiryeni.IskontoTutar
        this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.ToplamTutar -
          this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv

      },
      satirduzenle(params) {

        this.yedeksatirkayit.Tutar = params.Tutar
        this.yedeksatirkayit.Kdv = params.KdvTutar
        this.yedeksatirkayit.iskonto = params.IskontoTutar
        this.yedeksatirkayit.Tevkifat = params.TevkifatDetayTutar
        this.secilensatirno = this.satiritems.indexOf(params)
        this.SerbestFaturaDetay = params
        this.satirdialog = true
        this.satirguncellebuton = true
        this.satirkaydetbuton = false
      },
      satirsilsor(item) {
        this.dialogsor = true;
        this.faturasilbtn = false;
        this.satirsilbtn = true,
          this.silinecekkayit = item
      },
      faturasilsor() {
        this.dialogsor = true;
        this.faturasilbtn = true;
        this.satirsilbtn = false
      },
      satirsil() {
        const index = this.satiritems.indexOf(this.silinecekkayit)
        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar - this.silinecekkayit.Tutar
        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv - this.silinecekkayit.KdvTutar
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv - this.silinecekkayit.TevkifatDetayTutar
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto - this.silinecekkayit.IskontoTutar
        this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.ToplamTutar - this.SerbestFatura.Tutarlar
          .Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv
        this.satiritems.splice(index, 1)
        this.dialogsor = false;
      },
      tarihkontrol(v) {

        if (v != "0001-01-01T00:00:00" && v != null) {
          var parts1 = v.split("-");
          return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
        } else {
          return null;
        }
      },
      cariislemler() {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'))
        var params = {
          Code: this.SerbestFatura.Cari.Kod,
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/Current/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.unvan = response.body.Title

          if (response.body.CreditLimit == null || response.body.CreditLimit == '') {

            this.kredilimiti = parseFloat(0).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') +
              ' ₺'
          } else {
            this.kredilimiti = parseFloat(response.body.CreditLimit).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
                '$1,') +
              ' ₺'
          }

          this.SerbestFatura.EFaturaBilgi.Unvani = response.body.Title
          this.SerbestFatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
          this.SerbestFatura.EFaturaBilgi.IlçeSehir = response.body.Invoice.Province
          this.SerbestFatura.EFaturaBilgi.Email = response.body.Email
          this.SerbestFatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
          this.SerbestFatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
          this.SerbestFatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice.IdentityNumber
          this.SerbestFatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
          this.SerbestFatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName
          this.SerbestFatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
          this.SerbestFatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
          this.SerbestFatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix

          this.efaturatipigecici = String(response.body.EInvoiceType);


          //ana sirket e faturacı değilse kağıt fatura
          if (credentials.EFatura != '1') {

            this.SerbestFatura.Efaturakayit = false
            this.SerbestFatura.Earchiveakayit = false
            this.SerbestFatura.KagitFatura = true
          }


          if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '1') {
            // ana sirket efatura cari efatura o zaman efaturacı
            this.SerbestFatura.Efaturakayit = true
            this.SerbestFatura.Earchiveakayit = false
            this.SerbestFatura.KagitFatura = false

          }

          if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '0') {
            if (credentials.EArsiv == '1') {
              //anasirket efatura cari earsiv  o zaman earşivci
              this.SerbestFatura.Earchiveakayit = true
              this.SerbestFatura.Efaturakayit = false
              this.SerbestFatura.KagitFatura = false
            } else {
              this.SerbestFatura.Earchiveakayit = false
              this.SerbestFatura.Efaturakayit = false
              this.SerbestFatura.KagitFatura = true
            }
          }


          var params1 = {
            CompanyCode: credentials.SirketKodu,
          }

          if (this.SerbestFatura.Efaturakayit == true) {


            this.gibserigoster = true;

            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.gibseri = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else if (this.SerbestFatura.Earchiveakayit == true) {
            this.gibserigoster = true;
            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.gibseri = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else if (this.SerbestFatura.KagitFatura == true) {
            this.gibserigoster = false;
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })


      },
      guncelle: guncelle,
      satirekle: satirekle,
      ekle: ekle,
      getDateNow: getDateNow,
      getDateNow1: getDateNow1,
      toDateformat: toDateformat,
      carigetir: carigetir,
      Kaydet: Kaydet,
      satirkaydet: satirkaydet,
      kdvhesapla: kdvhesapla,
      iskontohesapla: iskontohesapla,
      iskontooranhesapla: iskontooranhesapla,
      Tevkifatkdvhesapla: Tevkifatkdvhesapla,
      anatevkifatkdvkontrol: anatevkifatkdvkontrol,
      anatevkifatiptal: anatevkifatiptal,
      kurgetir: kurgetir,
      tutardetayhesaplar: tutardetayhesaplar,
      earsivbilgigir: earsivbilgigir,
      FaturaGuncelle: FaturaGuncelle,
      faturasil: faturasil,
      faturabilgidegistir: faturabilgidegistir
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      'dovizinput': dovizinput,
      'yuzdeinput': yuzdeinput,
      'tarihcomp': tarihcomp,
      referansmerkezicomp,
      masrafmerkezicomp,
      reportbrosablon
    },
    watch: {
      search1(val) {
        val && this.carigetir(val)
      },

      'SerbestFatura.Cari.Kod': function (kod) {
        if (kod != null) {
          this.cariislemler();
        }
      },
      'SerbestFatura.Doviz.DovizKod': function (dovizkod) {
        if (dovizkod != null) {
          this.kurgetir();
        }
      },

      'SerbestFatura.EarsivBilgi.GonderimSekli': function (kod) {

        this.gonderimsekli.forEach(element => {
          if (kod == element.value) {

            this.gonderimlabel = element.text
          }
        });

      },
      'SerbestFatura.EarsivBilgi.InternetSatis': function (kod) {

        this.odemesekli.forEach(element => {
          if (kod == element.value) {
            this.internetsatislabel = element.text
          }
        });

      },
      'SerbestFatura.EarsivBilgi.WebAdresi': function (kod) {

        this.webadresleri.forEach(element => {
          if (kod == element.ID) {
            this.webadresilabel = element.Aciklama
          }
        });

      },
      'SerbestFatura.EarsivBilgi.OdemeSekli': function (kod) {

        this.odemesekli1.forEach(element => {
          if (kod == element.value) {
            this.odemeseklilabel = element.text
          }
        });

      },

      'SerbestFatura.EarsivBilgi.OdemeSekliAciklama': function (kod) {

        this.odemesekilleri.forEach(element => {
          if (kod == element.ID) {
            this.odemesekliaciklamalabel = element.Aciklama
          }
        });

      },
      'SerbestFatura.EarsivBilgi.OdemeAraci': function (kod) {

        this.odemearaci.forEach(element => {
          if (kod == element.ID) {
            this.odemearacilabel = element.Aciklama
          }
        });

      },

      'SerbestFaturaDetay.BirimFiyat': function () {

        if (this.SerbestFaturaDetay.Miktar > 0 && this.SerbestFaturaDetay.BirimFiyat >= 0) {
          this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
        } else {
          this.SerbestFaturaDetay.Tutar = 0
        }
      },
      'SerbestFaturaDetay.Miktar': function () {

        if (this.SerbestFaturaDetay.Miktar > 0 && this.SerbestFaturaDetay.BirimFiyat >= 0) {
          this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
        } else {
          this.SerbestFaturaDetay.Tutar = 0
        }
      },
      'SerbestFatura.EarsivBilgi.OdemeTarihi': function (deger) {
        this.odemetarihilabel = this.tarihkontrol(deger)
      },
      'SerbestFaturaDetay.Tutar': function (deger) {
        if (this.SerbestFatura.Kur != null && this.SerbestFatura.Kur != 0) {
          this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Tutar / this.SerbestFatura.Kur
        }

        if (deger == 0) {
          this.SerbestFaturaDetay.IskontoYuzde = 0;
        }

        if (deger == 0 && this.SerbestFaturaDetay.KdvYuzde != 0) {
          this.SerbestFaturaDetay.KdvYuzde = 0
        }

        if (deger != 0 && this.SerbestFaturaDetay.KdvYuzde != 0) {
          this.kdvhesapla();
        }


      },
      'SerbestFaturaDetay.IskontoTutar': function (deger) {

        if (deger == 0 || deger == null) {

          this.SerbestFaturaDetay.IskontoTutar = 0
          this.SerbestFaturaDetay.KdvTutar = 0
        } else {
          this.SerbestFaturaDetay.IskontoYuzde = deger / this.SerbestFaturaDetay.Tutar * 100
        }
      },
      'SerbestFaturaDetay.IskontoYuzde': function (deger) {

        if (deger == 0 || deger == null) {
          this.SerbestFaturaDetay.Tutar = 0
        } else {
          this.SerbestFaturaDetay.IskontoTutar = this.SerbestFaturaDetay.Tutar / 100 * deger
        }
      },
      'SerbestFaturaDetay.KdvYuzde': function (deger) {
        this.kdvhesapla();
      },
      'SerbestFaturaDetay.KdvTip': function (deger) {

        if (this.SerbestFaturaDetay.KdvYuzde != 0 && this.SerbestFaturaDetay.KdvYuzde != null)
          this.kdvhesapla();
      }

    }
  }


  function tutardetayhesaplar() {

    if (this.SerbestFatura.Kur != null && this.SerbestFatura.Kur != 0 && this.SerbestFatura.Kur != '' && this.SerbestFaturaDetay
      .Tutar != 0) {
      this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Tutar / this.SerbestFatura.Kur
    }

    if (this.SerbestFaturaDetay.IskontoYuzde != null && this.SerbestFaturaDetay.IskontoYuzde != '') {

      var params1 = {
        Tutar: this.SerbestFaturaDetay.Tutar,
        IskontoOran: this.SerbestFaturaDetay.IskontoYuzde
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.KdvTip != null
      this.SerbestFaturaDetay.IskontoYuzde = 0
      this.SerbestFaturaDetay.IskontoTutar = 0
    }

    if (this.SerbestFaturaDetay.IskontoTutar != null && this.SerbestFaturaDetay.IskontoTutar != '' && this.SerbestFaturaDetay
      .KdvYuzde != null && this.SerbestFaturaDetay.KdvYuzde != '') {
      var params1 = {
        KdvTip: this.SerbestFaturaDetay.KdvTip,
        Tutar: this.SerbestFaturaDetay.Tutar,
        IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
        KdvOran: this.SerbestFaturaDetay.KdvYuzde
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetTaxAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.KdvTutar = response.body.KdvTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Kdv Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Kdv Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.KdvYuzde = 0
      this.SerbestFaturaDetay.KdvTutar = 0
    }

    if (this.SerbestFaturaDetay.TevkifatDetayOran != null && this.SerbestFaturaDetay.TevkifatDetayOran != '' && this.SerbestFaturaDetay
      .KdvTutar != '' && this.SerbestFaturaDetay.KdvTutar != null && this.detaytevkifat == true) {

      var params1 = {
        TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
        KdvTutar: this.SerbestFaturaDetay.KdvTutar
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFaturaDetay.TevkifatDetayTutar = response.body.TevkifatTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Iskonto Hesapla'
          this.snackbar = true
        }
      })
    } else {
      this.SerbestFaturaDetay.TevkifatDetayOran = '0.0'
    }

  }

  function kurgetir() {

    var params1 = {
      Tarih: this.SerbestFatura.Tarih,
      DovizKod: this.SerbestFatura.Doviz.DovizKod
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetRate', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFatura.Kur = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })

  }

  function anatevkifatkdvkontrol() {
    if (this.SerbestFatura.TevkivatKdv != 0 && this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura.TevkivatKdv !=
      '') {
      if (this.SerbestFaturaDetay.TevkifatDetayOran != 0 && this.SerbestFaturaDetay.TevkifatDetayOran != null && this
        .SerbestFaturaDetay
        .TevkifatDetayOran != '') {

        this.text1 = 'Serbest Fatura Detay Ekranında Tevkifat Oranı Seçilidir.'
        this.snackbar = true
        this.SerbestFatura.TevkivatKdv = null

      } else {

        this.detaytevkifat = false
        this.SerbestFaturaDetay.TevkifatDetayOran = 0
        this.SerbestFaturaDetay.TevkifatDetayTutar = 0
      }


    } else {
      this.detaytevkifat = true
    }
  }

  function anatevkifatiptal() {

    if (this.SerbestFatura.TevkivatKdv === 0 || this.SerbestFatura.TevkivatKdv === null || this.SerbestFatura.TevkivatKdv ===
      '') {
      this.detaytevkifat = true
    }
  }

  function Tevkifatkdvhesapla() {
    var params1 = {
      TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
      KdvTutar: this.SerbestFaturaDetay.KdvTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.TevkifatDetayTutar = response.body.TevkifatTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function satirekle() {
    this.SerbestFaturaDetay.Referans.Kod = null
    this.satirdialog = true
    this.satirkaydetbuton = true
    this.satirguncellebuton = false
    this.SerbestFaturaDetay.MuhasebeKodu = ''
    this.SerbestFaturaDetay.MuhasebeKodu = ''
    this.SerbestFaturaDetay.Aciklama = ''
    this.SerbestFaturaDetay.LineNote = ''
    this.SerbestFaturaDetay.Masraf.Code = null
    this.SerbestFaturaDetay.Miktar = ''
    this.SerbestFaturaDetay.Birim = ''
    this.SerbestFaturaDetay.BirimFiyat = 0
    this.SerbestFaturaDetay.Tutar = 0
    this.SerbestFaturaDetay.DovizTutar = 0
    this.SerbestFaturaDetay.IskontoYuzde = 0
    this.SerbestFaturaDetay.IskontoTutar = 0
    this.SerbestFaturaDetay.KdvTip = 'D'
    this.SerbestFaturaDetay.KdvYuzde = 0
    this.SerbestFaturaDetay.KdvTutar = 0
    this.SerbestFaturaDetay.KdvMuhKodu = ''
    this.SerbestFaturaDetay.IskMuhKodu = ''
    this.SerbestFaturaDetay.KdvKodu = ''
    this.SerbestFaturaDetay.IstisnaKodu = ''
    this.SerbestFaturaDetay.TevkifatKodu = ''
    this.SerbestFaturaDetay.Tip = ''
    this.SerbestFaturaDetay.TevkifatDetayTutar = 0
    this.SerbestFaturaDetay.TevkifatDetayOran = ''
    this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.BinaNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti = ''
    this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme = ''
  }

  function satirkaydet() {

    if (this.SerbestFaturaDetay.DovizTutar > 0) {
      var n = this.SerbestFaturaDetay.DovizTutar
      this.SerbestFaturaDetay.DovizTutar = n.toFixed(4)

    }

    var satir = {
      TeslimBilgileri: {
        SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
        BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
        BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
        TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
        TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
        TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
        TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
        GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
        TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
        KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
        KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
        KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
        TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
      },
      MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
      Aciklama: this.SerbestFaturaDetay.Aciklama,
      Referans: {
        Kod: this.SerbestFaturaDetay.Referans.Kod
      },
      Masraf: {
        Code: this.SerbestFaturaDetay.Masraf.Code
      },
      Miktar: this.SerbestFaturaDetay.Miktar,
      LineNote: this.SerbestFaturaDetay.LineNote,
      Birim: this.SerbestFaturaDetay.Birim,
      BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
      Tutar: this.SerbestFaturaDetay.Tutar,
      TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
      DovizTutar: this.SerbestFaturaDetay.DovizTutar,
      TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
      IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
      KdvKodu: this.SerbestFaturaDetay.KdvKodu,
      KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
      IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
      KdvTutar: this.SerbestFaturaDetay.KdvTutar,
      KdvTip: this.SerbestFaturaDetay.KdvTip,
      KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
      IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
      TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
      Tip: this.SerbestFaturaDetay.Tip,
      AdresBilgi: {
        Unvani: null,
        Unvani2: null,
        Adres1: null,
        Adres2: null,
        IlceSehir: null,
        Email: null,
        VergiDairesi: null,
        VergiNo: null,
        TcKimlikNo: null,
        Adi: null,
        Soyadi: null,
        TUnvani: null,
        DigerAdi: null,
        OnAdiEki: null
      },
      EfaturaDetayBilgileri: {
        SiparisID: null,
        SiparisTarihi: null
      },
      AdresBilgi: {
        Unvani: null,
        Unvani2: null,
        Adres1: null,
        Adres2: null,
        IlceSehir: null,
        Email: null,
        VergiDairesi: null,
        VergiNo: null,
        TcKimlikNo: null,
        Adi: null,
        Soyadi: null,
        TUnvani: null,
        DigerAdi: null,
        OnAdiEki: null
      }
    }

    this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar + satir.Tutar
    this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv + satir.KdvTutar

    if (this.detaytevkifat === false) {

      var params1 = {
        TevkifatOran: this.SerbestFatura.TevkivatKdv,
        KdvTutar: this.SerbestFaturaDetay.KdvTutar
      }

      this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + response.body.TevkifatTutar
        this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satir.IskontoTutar
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-Tevkifat Hesapla'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable-Tevkifat Hesapla'
          this.snackbar = true
        }
      })

    } else {

      this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + satir.TevkifatDetayTutar
      this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satir.IskontoTutar
    }

    this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.ToplamTutar -
      this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv

    this.satiritems.push(satir)
    this.satirdialog = false

  }

  //kaydetme işlemi
  function Kaydet() {
    this.$validator.validateAll().then((result) => {

      if (this.dizayn != 0 && this.SerbestFatura.EFaturaShowID.XsltID != 0 && this.SerbestFatura.EFaturaShowID.DizaynID !=
        0) {

        if (result) {

          if (this.satiritems.length > 0) {


            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            this.SerbestFatura.EFaturaShowID.PdfID = this.dizayn

            if (this.nefaturasi == 'gelen' || this.nefaturasi == 'yenigelen') {
              this.SerbestFatura.Serbest = false
            } else {
              this.SerbestFatura.Serbest = true
            }

            this.SerbestFatura.SirketKodu = credentials.SirketKodu

            this.SerbestFatura.Detay = this.satiritems

            var params = this.SerbestFatura

            this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceAdd', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              if (response.body.Status === true) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true





                var url = '#/fatura/serbestfatura/id?' + 'ft=' + this.SerbestFatura.Tarih + '&ck=' + this
                  .SerbestFatura.Cari.Kod + '&et=' + 'SF' + '&es=' +
                  this.SerbestFatura.FaturaSeri + '&en=' + this.SerbestFatura.FaturaNo + '&ner=' + "X" +
                  '&sb=' + true + '&islem=get'
                window.open(url, '_self')




                setTimeout(function () {
                  window.location.reload(false);
                }.bind(this), 5000)







              } else {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
              }
            }, (response) => {
              if (response.status === 0) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })

          } else {
            this.text1 = 'Lütfen satır girişi yapınız'
            this.snackbar = true
          }
        } else {
          this.text1 = 'Zorunlu alanları doldurunuz'
          this.snackbar = true
        }
      } else {
        this.text1 = 'Lütfen fatura dizaynını seçiniz..'
        this.snackbar = true
      }

    })
  }

  function FaturaGuncelle() {

    if (this.dizayn != 0 && this.SerbestFatura.EFaturaShowID.XsltID != 0 && this.SerbestFatura.EFaturaShowID.DizaynID !=
      0) {

      this.$validator.validateAll().then((result) => {



        if (result) {

          if (this.satiritems.length > 0) {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            if (this.nefaturasi == 'gelen' || this.nefaturasi == 'yenigelen') {
              this.SerbestFatura.Serbest = false
            } else {
              this.SerbestFatura.Serbest = true
            }

            this.SerbestFatura.SirketKodu = credentials.SirketKodu

            this.SerbestFatura.Update = true


            this.SerbestFatura.Detay = this.satiritems

            var params = this.SerbestFatura

            this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceAdd', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              if (response.body.Status === true) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true

              } else {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
              }
            }, (response) => {
              if (response.status === 0) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })

          } else {
            this.text1 = 'Lütfen satır girişi yapınız'
            this.snackbar = true
          }


        } else {
          this.text1 = 'Lütfen zorunlu alanları doldurunuz'
          this.snackbar = true
        }

      })

    } else {
      this.text1 = 'Lütfen fatura dizaynını seçiniz..'
      this.snackbar = true
    }


  }

  function faturabilgidegistir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var opsiyonparams = {
      IskontoBas: false,
      DovizBas: false,
      OdemeBas: false,
      YolcuBas: false,
      CariBasma: false,
      Deleted: false,
    }



    if (this.islemturu == 0) {

      if (this.ChangeFaturaNo != null && this.ChangeFaturaNo != '') {

        var changeparams = {
          ChangeType: false, // false : numara, true : tarih
          YeniEvrakno: this.ChangeFaturaNo,
          YeniTarih: null
        }


        var params = {
          SirketKodu: credentials.SirketKodu,
          Tarih: this.SerbestFatura.Tarih,
          CariKod: this.SerbestFatura.Cari.Kod,
          EvrakTipi: null,
          EvrakSeri: this.SerbestFatura.FaturaSeri,
          Evrakno: this.SerbestFatura.FaturaNo,
          Nereden: 'X',
          Serbest: true,
          Opsiyonlar: opsiyonparams,
          ChangeInfo: changeparams,
        }


        this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceChange', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.dialogdegistir = false
            this.SerbestFatura.FaturaNo = this.ChangeFaturaNo




            // setTimeout(function () {

            //   var url = '#/fatura/faturalistesi'
            //   window.open(url, '_self')
            // }.bind(this), 5000)


          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.dialogsor = false
          } else {
            this.text1 = response.statusText
            this.snackbar = true
            this.dialogsor = false
          }
        })
      } else {
        this.text1 = 'Lütfen Fatura Numarası Giriniz.'
        this.snackbar = true
      }


    }

    if (this.islemturu == 1) {

      if (this.ChangeTarih != null && this.ChangeTarih != '' && typeof (this.ChangeTarih) != 'undefined') {

        var changeparams = {
          ChangeType: true, // false : numara, true : tarih
          YeniEvrakno: null,
          YeniTarih: this.ChangeTarih
        }


        var params = {
          SirketKodu: credentials.SirketKodu,
          Tarih: this.SerbestFatura.Tarih,
          CariKod: this.SerbestFatura.Cari.Kod,
          EvrakTipi: null,
          EvrakSeri: this.SerbestFatura.FaturaSeri,
          Evrakno: this.SerbestFatura.FaturaNo,
          Nereden: 'X',
          Serbest: true,
          Opsiyonlar: opsiyonparams,
          ChangeInfo: changeparams,
        }


        this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceChange', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.dialogdegistir = false
            this.SerbestFatura.Tarih = this.ChangeTarih
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
            this.dialogsor = false

          } else {
            this.text1 = response.statusText
            this.snackbar = true
            this.dialogsor = false

          }
        })

      }
    } else {
      this.text1 = 'Lütfen Yeni Fatura Tarihini Seçiniz.'
      this.snackbar = true
    }

  }


  function faturasil() {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      SirketKodu: credentials.SirketKodu,
      Tarih: this.SerbestFatura.Tarih,
      CariKod: this.SerbestFatura.Cari.Kod,
      EvrakTipi: null,
      EvrakSeri: this.SerbestFatura.FaturaSeri,
      Evrakno: this.SerbestFatura.FaturaNo,
      Nereden: 'X',
      Serbest: true
    }

    this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceDelete', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status === true) {
        this.text1 = response.body.ResponseMessage + ' fatura listesine yönlendiriliyorsunuz...'
        this.snackbar = true
        this.dialogsor = false



        setTimeout(function () {

          var url = '#/fatura/faturalistesi'
          window.open(url, '_self')
        }.bind(this), 5000)


      } else {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.dialogsor = false

      } else {
        this.text1 = response.statusText
        this.snackbar = true
        this.dialogsor = false

      }
    })
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function iskontooranhesapla() {
    var params1 = {
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountRate', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoOran
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function iskontohesapla() {


    var params1 = {
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoOran: this.SerbestFaturaDetay.IskontoYuzde
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Iskonto Hesapla'
        this.snackbar = true
      }
    })
  }

  function kdvhesapla() {

    var params1 = {
      KdvTip: this.SerbestFaturaDetay.KdvTip,
      Tutar: this.SerbestFaturaDetay.Tutar,
      IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
      KdvOran: this.SerbestFaturaDetay.KdvYuzde
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetTaxAmount', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SerbestFaturaDetay.KdvTutar = response.body.KdvTutar
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Kdv Hesapla'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Kdv Hesapla'
        this.snackbar = true
      }
    })
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }

  function carigetir(v) {

    this.statecari = []

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (v.length >= 0) {
      this.loading = true
      var query = {
        q: v,
        c: credentials.SirketKodu,
      }
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', query, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
        }, (response) => {
          if (response.status === 0) {

          } else {

          }
        })
        this.loading = false
      }, 500)
    }
  }

  function beforeMount() {



    this.SerbestFaturaDetayList = []

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));


    var params1 = {
      CompanyCode: credentials.SirketKodu,
    }


    this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.EvrakTipi1 = response.body
      this.SerbestFatura.Evrak.Evrakkod = 'SF';
    }, (response) => {
      if (response.status === 0) {
        console.log('')
      } else {
        console.log('')
      }
    })


    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      }
    })



    if (this.$route.query.islem == "yeni" || this.$route.query.islem == "get") {
      this.nefaturasi = 'serbest'
    }

    if (this.$route.query.islem == "yenigelenevrak" || this.$route.query.islem == "gelenevrak") {
      this.nefaturasi = 'gelen'
      this.faturatipi = [];
      var kayit = {
        text: 'Alış Faturası',
        value: 0
      }
      this.faturatipi.push(kayit);
      kayit = {
        text: 'Satış İadesi',
        value: 1
      }
      this.faturatipi.push(kayit);
      this.SerbestFatura.GibSeri = null,
        this.gibserigoster = false;
      this.gibseri = [];
      this.sayfabaslik = 'Gelen Fatura Yeni'
      this.SerbestFatura.CariAktarma = false;
    }



    if (this.$route.query.islem == "get" || this.$route.query.islem == "gelenevrak") {
      this.faturagosterbtn = true
      this.loadingdialog = true
      this.guncellebuton = true
      this.kaydetbuton = false
      this.seridisable = true
      this.aktifdate = true


      var params2 = {
        SirketKodu: credentials.SirketKodu,
        Tarih: this.$route.query.ft,
        CariKod: this.$route.query.ck,
        EvrakTipi: '',
        EvrakSeri: this.$route.query.es,
        Evrakno: this.$route.query.en,
        Nereden: this.$route.query.ner,
        Serbest: this.$route.query.sb,
      }


      this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceGet', params2, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.SerbestFatura = response.body



        //cariyi dolduruyoruz
        var statecariyeni = [{
          text: response.body.Cari.Kod + '-' + response.body.Cari.Unvan,
          id: response.body.Cari.Kod
        }]
        this.statecari = statecariyeni


        if (this.nefaturasi != 'gelen' && response.body.EFaturaShowID != null) {
          this.SerbestFatura.EFaturaShowID.EFaturaID = response.body.EFaturaShowID.EFaturaID
          this.SerbestFatura.EFaturaShowID.EFaturaGuid = response.body.EFaturaShowID.EFaturaGuid
          this.guidim = response.body.EFaturaShowID.EFaturaGuid
          this.idim = response.body.EFaturaShowID.EFaturaID
        }

        if (response.body.EFaturaShowID != null) {
          this.dizaynIdget = response.body.EFaturaShowID.DizaynID
          this.xsltIdget = response.body.EFaturaShowID.XsltID
          this.dizayn = response.body.EFaturaShowID.PdfID
        }

        this.satiritems = response.body.Detay
        this.loadingdialog = false

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.loadingdialog = false

        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.loadingdialog = false
        }
      })
    }


    this.dizayngetir();

    this.SerbestFatura.EFaturaShowID.DizaynID = this.dizaynIdget

    this.xsltgetir();

  }

  function earsivbilgigir() {
    this.dialogearsiv = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    //web adreslerini çekelim
    var params = {
      CompanyCode: credentials.SirketKodu,
      Type: '305'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.webadresleri = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-web adresleri'
        this.snackbar = true
      } else {

        this.text1 = 'Service Unavailable-web adresleri'
        this.snackbar = true
      }
    })


    //ödeme şekillerini çekelim
    var params = {
      CompanyCode: credentials.SirketKodu,
      Type: '306'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.odemesekilleri = response.body
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable-ödeme şekli'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ödeme şekli'
        this.snackbar = true
      }
    })
    // ödeme araçlarını alalalım
    var params = {
      CompanyCode: credentials.SirketKodu,
      Type: '307'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.odemearaci = response.body
    }, (response) => {
      if (response.status === 0) {

        this.text1 = 'Service Unavailable-ödeme aracı'
        this.snackbar = true
      } else {

        this.text1 = 'Service Unavailable-ödeme aracı'
        this.snackbar = true
      }
    })



  }

  function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
  }

  function ekle() {

    this.Current.Contract.ContractDate = this.SerbestFatura.Tarih

    var current = this.Current
    this.$http.post(auth.API_URL + 'api/Current/New', current, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      if (response.body.Status === true) {
        this.text1 = 'Kayıt Eklendi'
        this.snackbar = true
      } else if (response.body.Status === false) {
        this.text1 = 'Hata Oluştu'
        this.snackbar = true
      }
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = response.body.StatusText
        this.snackbar = true
      }
    })
  }

  function guncelle() {

    this.$validator.validateAll().then((result) => {
      if (result) {

        this.Current.Contract.ContractDate = this.SerbestFatura.Tarih
        var current = this.Current
        this.$http.post(auth.API_URL + 'api/Current/Update', current, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status === true) {
            this.text1 = 'Bilgiler Güncellendi'
            this.snackbar = true
          } else if (response.body.Status === false) {
            this.text1 = 'Hata Oluştu'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
  .outer {

    position: relative;
    display: inline-block;
    margin: 0 10px;
    padding-top: inherit+100px;

  }

  .inner {
    position: absolute;
    top: 104%;
    left: 50%;
    padding-block-start: 30px;
    padding-block-end: 10px;
  }

  .icorta {
    margin: 0px auto;
    height: 226px;
    color: #fff;
    position: absolute;
    left: 92%;
    top: 95%;
    margin-left: -110px;
    margin-top: -15px;
  }

  .rotate {
    -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);

  }
</style>